import { useEffect } from "react";
import { clearScopedAccount, isActingAsScopedAccount } from "./accountContext";

/**
 * Company ops pages (accounts list/detail/billing) should not keep a
 * "WORKING ON" client scope — that swaps the sidebar to owner menus.
 * Call on mount of /company/accounts* routes (not /company/staff/:id).
 */
export function useClearScopedAccountOnMount() {
  useEffect(() => {
    if (isActingAsScopedAccount()) {
      clearScopedAccount();
    }
  }, []);
}
